// ---------------------------------------------------------------------------
// LucidTopup - API configuration
// ---------------------------------------------------------------------------
// ต่อกับ PaymentBroker-Backend (api.swiftgoldpay.com) ชุด endpoint เดียวกับ
// Zenithlink-Market-Frontend
//   - auth / profile / order / payment  -> API จริง
//   - แคตตาล็อกเกม-บัตร-สินค้า-โปรโมชั่น -> mock (Backend ยังไม่มีตารางเกม)
// ---------------------------------------------------------------------------

// base url ต้องลงท้ายด้วย /api/
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.swiftgoldpay.com/api/";

// แคตตาล็อกยังเป็น mock อยู่ ตั้ง REACT_APP_USE_MOCK_CATALOG=false เมื่อ Backend พร้อม
export const USE_MOCK_CATALOG = process.env.REACT_APP_USE_MOCK_CATALOG !== "false";

export const MOCK_LATENCY = 180;

// key ใน localStorage ใช้ชุดเดียวกับ Zenithlink-Market เพื่อให้ helper เดิมใช้ร่วมกันได้
export const TOKEN_KEY = "scp-acc-tk";
export const PROFILE_KEY = "scp-profile";

// process_type = ระบุว่ารายการถูกสร้างจากหน้าบ้านตัวไหน (ฝั่ง Backend ใช้กรองประวัติ)
export const PROCESS_TYPE = "lucid_topup";

// order_type ใช้แยกประเภทรายการภายใน LucidTopup (Backend กรองด้วย ?order_type=)
export const ORDER_TYPE = {
  game: "game_topup",
  mobile: "mobile_topup",
  card: "card_topup",
  product: "product_order",
  credit: "credit_topup",
};

// ข้อมูล partner สำหรับเรียก transactions/deposits/partner
export const PARTNER = {
  clientId: process.env.REACT_APP_CLIENT_ID || "",
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || "",
  clientRefId: process.env.REACT_APP_CLIENT_REF_ID || "",
  apigwApiId: process.env.REACT_APP_X_APIGW_API_ID || "",
  customerIdDefault: process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "",
  currency: "THB",
};

export const CAPTCHA = {
  siteKey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
  masterToken: process.env.REACT_APP_CAPTCHA_TOKEN_MASTER || "",
};

// อายุ QR (วินาที) ใช้ตอน Backend ไม่ส่ง expire_datetime กลับมา
export const QR_EXPIRE_SECONDS = 600;
// ความถี่ในการเช็คสถานะการชำระเงิน
export const QR_POLL_MS = 5000;
// ความถี่ในการยิง inquiry ไปถาม gateway ต้นทาง (หนักกว่า จึงถี่น้อยกว่า)
export const QR_INQUIRY_MS = 20000;

export const ENDPOINTS = {
  // auth (public)
  login: "v1/public/market/login",
  logout: "v1/public/market/logout",
  register: "v1/public/market/customer",
  updateCustomer: (uid) => `v1/public/market/customer/${uid}`,
  customerAddress: "v1/public/market/customer-address",

  // profile (ต้องมี token)
  profile: "v1/market/profile",

  // orders
  orders: "v1/market/orders",
  orderCounts: "v1/market/orders/counts",
  order: (uid) => `v1/market/orders/${uid}`,
  orderDeliveryByTransaction: (transactionId) => `v1/market/orders/delivery/transaction/${transactionId}`,

  // payment
  depositPartner: "transactions/deposits/partner",
  depositGetById: "transactions/deposits/public/get-by-id",
  inquiry: "transactions/inquiry",
};
